// Every material belongs to exactly one of these four types. Single source
// of truth for the enum <-> label/color mapping, used by the sidebar,
// Material Master, Inventory, Dashboard, Site History, and My Profile.
export const MATERIAL_TYPES = [
  { value: 'FIXED_ASSETS',      label: 'Fixed Assets',      color: 'blue' },
  { value: 'POWER_TOOLS',       label: 'Power Tools',       color: 'orange' },
  { value: 'CONSUMABLE_ASSETS', label: 'Consumable Assets', color: 'green' },
  { value: 'SAFETY_ITEMS',      label: 'Safety Items',      color: 'indigo' },
];

export const MATERIAL_TYPE_LABELS = Object.fromEntries(MATERIAL_TYPES.map((t) => [t.value, t.label]));

export const MATERIAL_TYPE_COLORS = {
  blue:   'bg-blue-100 text-blue-700',
  orange: 'bg-orange-100 text-orange-700',
  green:  'bg-green-100 text-green-700',
  indigo: 'bg-indigo-100 text-indigo-700',
  gray:   'bg-gray-100 text-gray-500',
};

export const materialTypeBadgeClass = (type) => {
  const cfg = MATERIAL_TYPES.find((t) => t.value === type);
  return MATERIAL_TYPE_COLORS[cfg?.color] || MATERIAL_TYPE_COLORS.gray;
};

export const materialTypeLabel = (type) => MATERIAL_TYPE_LABELS[type] || type || '—';
